import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/arrow-left.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex md:w-176 items-start gap-4"
}
const _hoisted_2 = {
  key: 0,
  class: "flex md:w-176 items-start gap-4"
}
const _hoisted_3 = {
  key: 0,
  class: "flex md:w-176 items-start gap-4"
}
const _hoisted_4 = {
  key: 0,
  class: "flex md:w-51 items-start gap-4 mt-8"
}
const _hoisted_5 = {
  key: 0,
  class: "md:w-176 items-start gap-4 mt-4"
}
const _hoisted_6 = {
  id: "input_40_label",
  class: "formkit-label block text-base-bold text-racq-dark-grey mb-1 text-input-label input-xl sm:pe-8",
  for: "input_40"
}
const _hoisted_7 = {
  key: 1,
  class: "mt-8 mb-8 md:mb-6"
}
const _hoisted_8 = {
  key: 0,
  class: "flex md:w-[23rem] items-start gap-4 mt-4"
}
const _hoisted_9 = {
  key: 0,
  class: "md:w-176 items-start gap-4 mt-4"
}
const _hoisted_10 = {
  id: "postalreadonly_label",
  class: "formkit-label block text-base-bold text-racq-dark-grey mb-1 text-input-label input-xl sm:pe-8",
  for: "postalreadonly"
}
const _hoisted_11 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_12 = {
  key: 0,
  class: "flex md:w-[23rem] items-start gap-4 mt-4"
}
const _hoisted_13 = { class: "flex w-[640px] mt-12 items-start content-start gap-4 flex-wrap" }
const _hoisted_14 = { class: "flex items-center space-x-2" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "!mt-10 mb-10 md:!mt-12 md:!mb-12" }

import { onMounted, ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { v4 } from 'uuid';
import { ISitecoreFormGenericInput, RACQAddressResult } from '@/interfaces';
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import { getFormInput } from '@/utils/form-input-helper';
import { PageAnalyticsBuilder } from '@/utils/page-analytics-builder';
import InformationBox from '@/components/InformationBox/InformationBox.vue';
import AddressLookupOptions from '@/components/AddressLookupOptions/AddressLookupOptions.vue';
import { useAccountStore, useAddressLookupStore, useAnalyticsStore } from '@/store';
import { ToastAlertType } from '@/enums/toast-alert-enum';
import { useToastAlertStore } from '@/store/toast-alert/toast-alert.state';
import { cloneDeep } from 'lodash-es';
import FullScreenSpinner from '@/components/FullScreenSpinner/FullScreenSpinner.vue';
import { INameValue } from '@/interfaces/entities/name-value.interface';
import { AUSTRALIA, AUSTRALIA_ISO } from '@/constants/general-words.const';
import { showTooltipOnTriggerClick } from '@/plugins/tooltip/renderTooltip';
import { FormKit } from '@formkit/vue';
import { FormEvents } from '@/enums/form-events.enum';
import Divider from '@/components/Divider/Divider.vue';
import { Link } from '@sitecore-jss/sitecore-jss-vue';
import {
  mapAddressResultToIdentityAddress,
  mapIdentityAddressToAddressResult,
} from '@/mappers/identity-address.mapper';
import { Address } from '@/interfaces';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChangeAddressPage',
  props: {
    content: {},
    id: {},
    name: {}
  },
  setup(__props: any) {

const formData = ref<Record<string, any>>({});

const accountStore = useAccountStore();
const toastAlertStore = useToastAlertStore();
const analyticsStore = useAnalyticsStore();

const residentialIdentifier = v4();
const residentialAddressEl = ref<InstanceType<typeof AddressLookupOptions>>();
const residentialAddressStore = computed(() => residentialAddressEl.value?.getStore());

const postalIdentifier = v4();
const postalAddressEl = ref<InstanceType<typeof AddressLookupOptions>>();
const postalAddressStore = computed(() => postalAddressEl.value?.getStore());

const enteredResidentialAddress = ref<Partial<RACQAddressResult>>();
const enteredPostalAddress = ref<Partial<RACQAddressResult>>();
const showInternationAddressMessage = ref<boolean>(false);

const displayOnlyResidentialAddress = ref<string>('');
const displayOnlyPostalAddress = ref<string>('');

const showInvalidResidentialMessage = ref<boolean>(false);
const showInvalidPostalMessage = ref<boolean>(false);

const disableDiscardButton = ref<boolean>(false);
const hasChanges = ref<boolean>(false);

const props = __props;

const internationalAddressMessage = ref(getFormInput(props.content, 'internationalAddressMessage'));
const updateAddressMessageForBoth = ref(getFormInput(props.content, 'updateAddressMessageForBoth'));
const updateAddressMessageForBank = ref(getFormInput(props.content, 'updateAddressMessageForBank'));
const updateAddressMessageForInsurance = ref(getFormInput(props.content, 'updateAddressMessageForInsurance'));
const residentialAddress = ref(getFormInput(props.content, 'residentialAddress'));
const postalAddress = ref(getFormInput(props.content, 'postalAddress'));

const invalidResidentialMessage = ref(getFormInput(props.content, 'invalidResidentialMessage'));
const invalidPostalMessage = ref(getFormInput(props.content, 'invalidPostalMessage'));
const discardChangesLink = ref(getFormInput(props.content, 'discardChangesLink'));

const showLoadingOrSaving = ref<boolean>(true);
const countries = ref<any[]>([]);
const showUpdateAddressMessageFor = ref<string>();

const dictionary = useI18n().getLocaleMessage('en') as Record<string, string>;

onMounted(async () => {
  await setAddresses();
  showLoadingOrSaving.value = false;

  const hasBanking = (accountStore.identityDetails?.portfolio?.bankingProducts?.length ?? 0) > 0;
  const hasInsurance = (accountStore.identityDetails?.portfolio?.insurancePolicies?.length ?? 0) > 0;

  if (hasBanking && hasInsurance) {
    showUpdateAddressMessageFor.value = 'updateAddressMessageForBoth';
  } else if (hasBanking) {
    showUpdateAddressMessageFor.value = 'updateAddressMessageForBank';
  } else if (hasInsurance) {
    showUpdateAddressMessageFor.value = 'updateAddressMessageForInsurance';
  }

  pushAnalytics();

  //Fixes styling issue when page content is short
  const mainElement = document.querySelector('main');
  if (mainElement) {
    mainElement.classList.add('grow-0');
  }
});

const buildAddressLine = async (address: RACQAddressResult, isPostal: boolean, addressStore: any) => {
  if ((countries.value?.length ?? 0) === 0) {
    countries.value = (await lookupCountry()) ?? [];
  }

  const country = countries.value.find((x) => x.value === address.country);

  if (isPostal) {
    if (enteredPostalAddress.value) {
      displayOnlyPostalAddress.value =
        addressStore?.buildInternationalAddressLine(enteredPostalAddress.value, country?.label) ?? '';
    }
  } else if (enteredResidentialAddress.value) {
    displayOnlyResidentialAddress.value =
      addressStore?.buildInternationalAddressLine(enteredResidentialAddress.value, country?.label) ?? '';
  }
};

const lookupCountry = async () => {
  try {
    if (postalAddressStore?.value) {
      const tempStore = useAddressLookupStore();
      const data: INameValue[] = await tempStore.getCountryLookup('', true, true);
      return (
        data?.map((item: INameValue) => ({
          label: item.name,
          value: item.value,
        })) || []
      );
    }
  } catch {
    return [];
  }
};

const setAddresses = async () => {
  let residentialIsOs = false;
  let postalIsOs = false;

  enteredResidentialAddress.value = cloneDeep(
    accountStore.identityDetails?.addresses?.find((x) => x.addressType === 'Residential')
  );

  if (enteredResidentialAddress.value) {
    enteredResidentialAddress.value = mapIdentityAddressToAddressResult(enteredResidentialAddress.value);
  }

  residentialAddressStore.value?.setupAddressComponent(
    {
      isPostalAddress: false,
      allowOverseasAddress: false,
      allowPhysicalAddressesOnly: true,
      showPostalSameAsInsuredAddressSelection: false,
      manualAddressConfirmationOnChangeOnly: true,
    },
    enteredResidentialAddress.value,
    enteredResidentialAddress.value
  );
  if (residentialAddressStore.value) residentialAddressStore.value.showDividerForManualAddress = true;

  if (
    enteredResidentialAddress?.value &&
    (enteredResidentialAddress?.value?.country?.length ?? 0) >= 3 &&
    enteredResidentialAddress?.value.country?.toLowerCase() !== AUSTRALIA_ISO.toLowerCase()
  ) {
    residentialIsOs = true;
    showInternationAddressMessage.value = true;
    await buildAddressLine(enteredResidentialAddress.value, false, residentialAddressStore.value);
  }

  enteredPostalAddress.value = cloneDeep(
    accountStore.identityDetails?.addresses?.find((x) => x.addressType === 'Postal')
  );

  //Mapping this to handle PO box so it displays correct.
  if (enteredPostalAddress.value) {
    enteredPostalAddress.value = mapIdentityAddressToAddressResult(enteredPostalAddress.value);
  }

  postalAddressStore.value?.setupAddressComponent(
    {
      isPostalAddress: true,
      allowOverseasAddress: false,
      showPostalSameAsInsuredAddressSelection: false,
      manualAddressConfirmationOnChangeOnly: true,
    },
    enteredPostalAddress.value,
    enteredPostalAddress.value
  );

  if (
    enteredPostalAddress?.value &&
    (enteredPostalAddress?.value?.country?.length ?? 0) >= 3 &&
    enteredPostalAddress?.value.country?.toLowerCase() !== AUSTRALIA_ISO.toLowerCase()
  ) {
    postalIsOs = true;
    showInternationAddressMessage.value = true;
    await buildAddressLine(enteredPostalAddress.value, true, postalAddressStore.value);
  }

  disableDiscardButton.value = residentialIsOs && postalIsOs;
};

function onResidentialAddressSelected(address: Partial<RACQAddressResult>) {
  hasChanges.value = true;
  enteredResidentialAddress.value = address;
}

function onResidentialManualAddressSelected(address: Partial<RACQAddressResult>) {
  hasChanges.value = true;
  enteredResidentialAddress.value = address;
}

function onPostalAddressSelected(address: Partial<RACQAddressResult>) {
  hasChanges.value = true;
  enteredPostalAddress.value = address;
}

function onPostalManualAddressSelected(address: Partial<RACQAddressResult>) {
  hasChanges.value = true;
  enteredPostalAddress.value = address;
}

const onSave = async () => {
  showInvalidResidentialMessage.value = residentialAddressStore.value?.manualEditEnabled ?? false;
  showInvalidPostalMessage.value = postalAddressStore.value?.manualEditEnabled ?? false;

  if (showInvalidResidentialMessage.value || showInvalidPostalMessage.value) return;

  if (!enteredResidentialAddress.value || !enteredPostalAddress.value) {
    toastAlertStore.addToastAlert({
      title: 'Not all addresses have been completed',
      description: '',
      type: ToastAlertType.ERROR,
      duration: 6000,
    });

    return;
  }

  showLoadingOrSaving.value = true;

  try {
    const isResidentialAusAddress =
      enteredResidentialAddress.value.country?.toLowerCase() === AUSTRALIA.toLowerCase() ||
      enteredResidentialAddress.value.country?.toLowerCase() === AUSTRALIA_ISO.toLowerCase();
    const updateResidentialAddress = isResidentialAusAddress ? enteredResidentialAddress.value : undefined;

    const isPostalAusAddress =
      enteredPostalAddress.value.country?.toLowerCase() === AUSTRALIA.toLowerCase() ||
      enteredPostalAddress.value.country?.toLowerCase() === AUSTRALIA_ISO.toLowerCase();
    const updatePostalAddress = isPostalAusAddress ? enteredPostalAddress.value : undefined;

    const residentialAddress = mapAddressResultToIdentityAddress(updateResidentialAddress ?? {}, false);
    const postalAddress = mapAddressResultToIdentityAddress(updatePostalAddress ?? {}, true);

    hasChanges.value = false;

    await accountStore.updateAddressInformation(
      accountStore.identityDetails?.d365Id ?? '',
      handleValidAddress(residentialAddress),
      handleValidAddress(postalAddress)
    );

    await accountStore.fetchIdentityDetails(true);

    showLoadingOrSaving.value = false;

    toastAlertStore.addToastAlert({
      title: 'Account addresses updated',
      description: '',
      type: ToastAlertType.SUCCESS,
      duration: 6000,
    });

    await analyticsStore.pushAnalytics({
      event: FormEvents.COMPLETE,
      form: {
        name: 'Change profile address',
        stepName: 'FormCompleted',
      },
    });
  } catch (error) {
    showLoadingOrSaving.value = false;
    toastAlertStore.addToastAlert({
      title: 'Unable to save changes',
      description: '',
      type: ToastAlertType.ERROR,
      duration: 6000,
    });

    await analyticsStore.pushAnalytics({
      event: FormEvents.JEOPARDY,
      form: {
        name: 'Change profile address',
        formErrorType: 'Unable to save changes',
        formErrorDetail: 'Unable to save changes',
      },
    });
  }
};

//When an international address exists it can't be edited so we want to pass undefined for that address
//to prevent the server from trying to update it.
const handleValidAddress = (address: Address) => {
  if ((address?.street?.length ?? 0) === 0 || (address?.suburb?.length ?? 0) === 0) {
    return undefined;
  }

  return address;
};

const pushAnalytics = () => {
  const pageAnalytics = new PageAnalyticsBuilder();
  pageAnalytics.populateProducts(dictionary);
  pageAnalytics.pushAnalytics();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FormKit), {
    modelValue: formData.value,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData).value = $event)),
    type: "form",
    onSubmit: onSave
  }, {
    default: _withCtx(() => [
      _createVNode(FormStepInputs, {
        step: {
        stepName: _ctx.name,
        formInputs: _ctx.content,
      }
      }, {
        updateAddressMessageForBoth: _withCtx(() => [
          (showUpdateAddressMessageFor.value === 'updateAddressMessageForBoth')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(InformationBox, {
                  title: updateAddressMessageForBoth.value.title.value,
                  description: updateAddressMessageForBoth.value.content.value,
                  type: updateAddressMessageForBoth.value.messageType.value,
                  isCircle: true,
                  useButtonSlot: false
                }, null, 8, ["title", "description", "type"])
              ]))
            : _createCommentVNode("", true)
        ]),
        updateAddressMessageForBank: _withCtx(() => [
          (showUpdateAddressMessageFor.value === 'updateAddressMessageForBank')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(InformationBox, {
                  title: updateAddressMessageForBank.value.title.value,
                  description: updateAddressMessageForBank.value.content.value,
                  type: updateAddressMessageForBank.value.messageType.value,
                  isCircle: true,
                  useButtonSlot: false
                }, null, 8, ["title", "description", "type"])
              ]))
            : _createCommentVNode("", true)
        ]),
        updateAddressMessageForInsurance: _withCtx(() => [
          (showUpdateAddressMessageFor.value === 'updateAddressMessageForInsurance')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(InformationBox, {
                  title: updateAddressMessageForInsurance.value.title.value,
                  description: updateAddressMessageForInsurance.value.content.value,
                  type: updateAddressMessageForInsurance.value.messageType.value,
                  isCircle: true,
                  useButtonSlot: false
                }, null, 8, ["title", "description", "type"])
              ]))
            : _createCommentVNode("", true)
        ]),
        internationalAddressMessage: _withCtx(() => [
          (showInternationAddressMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(InformationBox, {
                  title: internationalAddressMessage.value.title.value,
                  description: internationalAddressMessage.value.content.value,
                  type: internationalAddressMessage.value.messageType.value,
                  isCircle: false,
                  hideIcon: true,
                  useButtonSlot: false
                }, null, 8, ["title", "description", "type"])
              ]))
            : _createCommentVNode("", true)
        ]),
        residentialAddress: _withCtx(() => [
          (
            enteredResidentialAddress.value &&
            (enteredResidentialAddress.value?.country?.length ?? 0) >= 3 &&
            enteredResidentialAddress.value?.country?.toLowerCase() !== _unref(AUSTRALIA_ISO).toLowerCase() &&
            enteredResidentialAddress.value?.country?.toLowerCase() !== _unref(AUSTRALIA).toLowerCase()
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, [
                  _createTextVNode(_toDisplayString(residentialAddress.value.label.value) + " ", 1),
                  _createElementVNode("button", {
                    id: "residentialAddressTooltipBtn",
                    type: "button",
                    class: "questionmark-icon js-tooltip-trigger -mt-0.5 inline-block",
                    "aria-label": "show tooltip",
                    onClick: _cache[0] || (_cache[0] = 
                (e) => {
                  _unref(showTooltipOnTriggerClick)(e, residentialAddress.value.tooltipContent?.value ?? '');
                }
              )
                  })
                ]),
                _createVNode(_unref(FormKit), {
                  id: "residentialreadonly",
                  modelValue: displayOnlyResidentialAddress.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((displayOnlyResidentialAddress).value = $event)),
                  innerClass: "input-xl",
                  disabled: true,
                  type: "autocomplete",
                  autocomplete: "off",
                  maxLength: "255",
                  listboxButtonClass: "$reset hidden",
                  loaderIconClass: "$reset hidden"
                }, null, 8, ["modelValue"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(AddressLookupOptions, _mergeProps({
                  ref_key: "residentialAddressEl",
                  ref: residentialAddressEl,
                  instanceIdentifier: _unref(residentialIdentifier)
                }, residentialAddress.value, {
                  defaultIsOverseasOption: false,
                  onManualAddressSelected: _cache[2] || (_cache[2] = 
              (address) => onResidentialManualAddressSelected(address)
            ),
                  onAddressSelected: _cache[3] || (_cache[3] = (address) => onResidentialAddressSelected(address))
                }), null, 16, ["instanceIdentifier"])
              ]))
        ]),
        invalidResidentialMessage: _withCtx(() => [
          (showInvalidResidentialMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(InformationBox, {
                  title: invalidResidentialMessage.value.title.value,
                  description: invalidResidentialMessage.value.content.value,
                  type: invalidResidentialMessage.value.messageType.value,
                  isCircle: false,
                  hideIcon: false,
                  useButtonSlot: false
                }, null, 8, ["title", "description", "type"])
              ]))
            : _createCommentVNode("", true)
        ]),
        postalAddress: _withCtx(() => [
          (
            enteredPostalAddress.value &&
            (enteredPostalAddress.value?.country?.length ?? 0) >= 3 &&
            enteredPostalAddress.value?.country?.toLowerCase() !== _unref(AUSTRALIA_ISO).toLowerCase() &&
            enteredPostalAddress.value?.country?.toLowerCase() !== _unref(AUSTRALIA).toLowerCase()
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, [
                  _createTextVNode(_toDisplayString(postalAddress.value.label.value) + " ", 1),
                  _createElementVNode("button", {
                    id: "postalAddressTooltipBtn",
                    type: "button",
                    class: "questionmark-icon js-tooltip-trigger -mt-0.5 inline-block",
                    "aria-label": "show tooltip",
                    onClick: _cache[4] || (_cache[4] = 
                (e) => {
                  _unref(showTooltipOnTriggerClick)(e, postalAddress.value.tooltipContent?.value ?? '');
                }
              )
                  })
                ]),
                _createVNode(_unref(FormKit), {
                  id: "postalreadonly",
                  modelValue: displayOnlyPostalAddress.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((displayOnlyPostalAddress).value = $event)),
                  bindings: postalAddress.value,
                  innerClass: "input-xl",
                  disabled: true,
                  type: "autocomplete",
                  autocomplete: "off",
                  maxLength: "255",
                  listboxButtonClass: "$reset hidden",
                  loaderIconClass: "$reset hidden"
                }, null, 8, ["modelValue", "bindings"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(AddressLookupOptions, _mergeProps({
                  ref_key: "postalAddressEl",
                  ref: postalAddressEl,
                  instanceIdentifier: _unref(postalIdentifier)
                }, postalAddress.value, {
                  defaultIsOverseasOption: false,
                  onManualAddressSelected: _cache[6] || (_cache[6] = (address) => onPostalManualAddressSelected(address)),
                  onAddressSelected: _cache[7] || (_cache[7] = (address) => onPostalAddressSelected(address))
                }), null, 16, ["instanceIdentifier"])
              ]))
        ]),
        invalidPostalMessage: _withCtx(() => [
          (showInvalidPostalMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(InformationBox, {
                  title: invalidPostalMessage.value.title.value,
                  description: invalidPostalMessage.value.content.value,
                  type: invalidPostalMessage.value.messageType.value,
                  isCircle: false,
                  hideIcon: false,
                  useButtonSlot: false
                }, null, 8, ["title", "description", "type"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["step"]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_unref(Link), {
          field: discardChangesLink.value?.link,
          class: "btn btn-tertiary btn-md"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _cache[9] || (_cache[9] = _createElementVNode("img", {
                src: _imports_0,
                alt: "left arrow",
                class: "w-5 h-5 inline-block"
              }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(discardChangesLink.value?.link?.value?.text), 1)
            ])
          ]),
          _: 1
        }, 8, ["field"]),
        _createElementVNode("button", {
          disabled: !hasChanges.value,
          type: "submit",
          class: "btn btn-md btn-primary"
        }, _toDisplayString(_unref(getFormInput)(props.content, 'saveButtonText')?.label?.value ?? 'Save changes'), 9, _hoisted_15)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(Divider)
      ]),
      (showLoadingOrSaving.value)
        ? (_openBlock(), _createBlock(FullScreenSpinner, {
            key: 0,
            applyOpacity: true
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})